<template>
  <div class="controls-selector">
    <sc-text tag="h3" class="title" :field="fields.title" />

    <div class="dropdown" :class="{ active: isActive }">
      <button class="dropbtn" @click="openVersions">{{ getActiveVersion() }}</button>
      <div class="dropdown-content">
        <div class="dropdown-content__versions" v-if="versions">
          <a
            :href="version?.fields?.url?.url"
            :class="{ active: version?.fields?.label?.value === getActiveVersion() }"
            v-for="version in versions"
            :key="version.id"
          >
            {{ version?.fields?.label?.value }}
          </a>
        </div>
        <div class="dropdown-content__text" v-if="fields && fields.olderVersionCta">
          <sc-link
            class="dropdown-content__cta"
            v-if="fields && fields.olderVersionCta"
            :field="fields.olderVersionCta"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Text, Link } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Controls-Navigator-Selector',
  components: {
    ScText: Text,
    ScLink: Link
  },
  props: {
    fields: {
      type: Object,
      default: () => ({})
    }
  },
  data: function () {
    return {
      isActive: false,
      currentVersion: 0
    };
  },
  mounted() {
    if (document) {
      document.addEventListener('click', () => {
        this.isActive = false;
      });
    }
  },
  computed: {
    versions() {
      return this.fields.versions || [];
    },
    urlName() {
      return this.$jss?.routeData()?.name;
    }
  },
  methods: {
    openVersions(event) {
      event.stopPropagation();
      this.isActive = !this.isActive;
    },
    getActiveVersion() {
      var versionMatchUrlName = this.versions.filter((i) => {
        var url = i?.fields?.url?.url;
        var name = url?.lastIndexOf('/');
        var result = url?.substring(name + 1);
        if (result === this.urlName) return i;
      });

      return versionMatchUrlName[0]?.fields?.label?.value;
    }
  }
};
</script>
<style scoped lang="scss">
.controls-selector {
  display: block;
  margin-top: 2.5rem;
  padding-left: 2rem;

  @include desktop-up {
    display: none;
    padding-left: 0;
  }

  .title {
    display: inline-block;
    font-size: 2rem;
    line-height: 2.6rem;

    @include desktop-up {
      font-size: 2.8rem;
      line-height: 3.5rem;
    }
  }
  .dropdown {
    position: relative;
    display: inline-block;
    margin: 0 0 2rem 1rem;

    .dropbtn {
      border: none;
      border-bottom: solid 0.1rem $black;
      background-color: $white;
      @include font-styles('Arial', 2rem, 200, normal, 2.6rem, 0, $blue);
      padding: 0 0.5rem 0 0;
      cursor: pointer;

      @include desktop-up {
        font-size: 2.8rem;
        line-height: 3.5rem;
      }

      &::after {
        content: '';
        border: solid $blue;
        border-width: 0 0.15rem 0.15rem 0;
        display: inline-block;
        padding: 0.5rem;
        margin-left: 2rem;
        right: 1rem;
        top: 50%;
        transform: translate(0, -0.5rem) rotate(45deg);
        transition: 0.25s all ease-in-out;
      }
    }

    .dropdown-content {
      position: absolute;
      border-radius: 1rem;
      background: linear-gradient(
        169deg,
        rgba(0, 0, 0, 1) 0%,
        rgba(0, 59, 92, 1) 20%,
        rgba(0, 134, 191, 1) 100%
      );
      box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.32);
      z-index: 98;
      max-height: 0;
      min-width: 23rem;
      transition: max-height 0.15s ease-out;
      overflow: hidden;
      left: -1rem;

      &__versions {
        margin: 1.5rem 1.5rem 1.5rem 1.5rem;
        padding-bottom: 1.5rem;
        border-bottom: solid 0.1rem $white;

        a {
          @include font-styles('Arial', 2rem, 200, normal, 2.6rem, 0, $white);
          border-radius: 1rem;
          padding: 0.5rem 1rem;
          text-decoration: none;
          display: block;

          &.active {
            font-weight: 400;
          }

          &:hover {
            background-color: rgba(0, 59, 92, 0.7);
          }
        }
      }

      &__text {
        display: block;
        margin: 0 1.5rem 1.5rem 1.5rem;

        a {
          @include font-styles('Arial Narrow', 1.8rem, 500, normal, 2.2rem, 0, $white);
          display: inline-flex;
          text-transform: uppercase;
          justify-content: flex-start;
          align-items: center;

          &:hover {
            font-weight: 500;
            background: none;

            &:after {
              left: 0.5rem;
            }
          }

          &:after {
            content: '';
            position: relative;
            background-image: url(~@/assets/images/icon-arrow-right-white.svg);
            background-size: contain;
            background-repeat: no-repeat;
            margin-left: 1rem;
            width: 1.9rem;
            min-width: 1.9rem;
            height: 1.5rem;
            min-height: 1.5rem;
            transition: 0.25s;
            left: 0;
          }
        }
      }

      &__cta {
        @include font-styles('Arial Narrow', 1.8rem, 600, normal, 2.2rem, 0, $white);
      }
    }

    &.active {
      .dropbtn {
        border: none;
        transition: max-height 0.25s ease-in;

        &::after {
          transform: rotate(-135deg) translate(0, 0);
          top: 50%;
          right: 1rem;
        }
      }
      .dropdown-content {
        max-height: 500px;
        min-width: 23rem;
        transition: max-height 0.25s ease-in;
      }
    }
  }
}

.column {
  .controls-selector {
    display: none;

    @include desktop-up {
      display: block;
    }
  }
}

//editing
.controls-selector {
  &.scEnabledChrome {
    display: block;
  }
}
</style>
